import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	cardName: {
		id: 'redesign.purchase.creditCardForm.cardName',
		defaultMessage: 'Name on Credit Card',
		description: 'CC Name Prompt',
	},
	email: {
		id: 'generics.email',
		defaultMessage: 'Email',
		description: 'CC Email Prompt',
	},
	yourEmail: {
		id: 'generics.yourEmail',
		defaultMessage: 'Your Email',
		description: 'CC Your Email',
	},
	emptyEmailError: {
		id: 'generics.emptyEmail',
		defaultMessage: 'Email is required!',
		description: 'CC Email Required',
	},
	firstName: {
		id: 'redesign.purchase.creditCardForm.nameOnCard',
		defaultMessage: 'Name on Card',
		description: 'CC Name on Card',
	},
	firstNameError: {
		id: 'generics.nameOnCardError',
		defaultMessage: 'Name on Card is required!',
		description: 'CC Name Required',
	},
	emailError: {
		id: 'giftCertificate.purchaseForm.emailError',
		defaultMessage: 'Please enter a valid email address.',
		description: 'CC Email Error',
	},
	expiryPlaceholder: {
		id: 'redesign.purchase.creditCardForm.expiryPlaceholder',
		defaultMessage: 'Exp (MM / YY)',
		description: 'CC Expiry Prompt',
	},
	cvcPlaceholder: {
		id: 'redesign.purchase.creditCardForm.cvcPlaceholder',
		defaultMessage: 'CVC',
		description: 'CC CVC Prompt',
	},
	postalCode: {
		id: 'redesign.purchase.creditCardForm.postalCode',
		defaultMessage: 'Billing Zip Code',
		description: 'CC Zip Prompt',
	},
	failedCaptcha: {
		id: 'redesign.purhcase.creditCardForm.failedCaptcha',
		defaultMessage: 'Oops! Something went wrong. Please try again.',
		description: 'CC Captcha Failed',
	},
	startFreeTrial: {
		id: 'redesign.purchase.creditCardForm.button.startFreeTrial',
		defaultMessage: 'Start Free Trial',
		description: 'Default credit card form button text',
	},
	useCard: {
		id: 'redesign.purchase.creditCardForm.button.useCard',
		defaultMessage: 'Get Calm Premium',
		description: 'Button text for already subbed',
	},
	success: {
		id: 'redesign.purchase.creditCardForm.button.success',
		defaultMessage: 'Success',
		description: 'Button text for successful purchase',
	},
	samsungSubscribeLink: {
		id: 'redesign.purchase.creditCardForm.samsungErrorLink',
		defaultMessage: 'Redeem Regular Subscription',
		description: 'A link to go to a subscribe page without a promotional price',
	},
	promotionTrialDurationSevenDays: {
		id: 'promotionOptions.promotionTrialDurationSevenDays',
		defaultMessage: 'Seven Day',
		description: 'Description of a trial length of seven days',
	},
	promotionTrialDurationFourteenDays: {
		id: 'promotionOptions.promotionTrialDurationFourteenDays',
		defaultMessage: 'Fourteen Day',
		description: 'Description of a trial length of fourteen days',
	},
	promotionTrialDurationOneMonth: {
		id: 'promotionOptions.promotionTrialDurationOneMonth',
		defaultMessage: 'One Month',
		description: 'Description of a trial length of one month',
	},
	promotionTrialDurationTwoMonths: {
		id: 'promotionOptions.promotionTrialDurationTwoMonths',
		defaultMessage: 'Two Month',
		description: 'Description of a trial length of two months',
	},
	promotionTrialDurationThreeMonths: {
		id: 'promotionOptions.promotionTrialDurationThreeMonths',
		defaultMessage: 'Three Month',
		description: 'Description of a trial length of three months',
	},
	promotionTrialDurationSixMonths: {
		id: 'promotionOptions.promotionTrialDurationSixMonths',
		defaultMessage: 'Six Month',
		description: 'Description of a trial length of six months',
	},
});
